// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `  .reels-grid {
    display: flex;
    gap: 16px;
    justify-content: center;
    flex-wrap: wrap;
  }
  
  .cmn-reels-container {
    width: 1000px;
    height: 800px;
    border-radius: 20px;
    margin-left: 0px;
    margin-top: -100px;
    display: flex;
    flex-direction: row;
    gap: 50px
  }

  .reel-card {
    position: relative;
    background-color: white;
    width: 100%;
    max-width: 250px;
    border-radius: 12px;
    border-color: black;
    overflow: hidden;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    flex: 0 0 auto; /* Prevents resizing */
    margin-right: 10px; /* Adds spacing between reels */ 
    display: flex;
    flex-direction: row;
    gap: 10px;
    margin-top: 100px;
    height: 40px;
}
  
  .reel-card:hover {
    transform: scale(1.02);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
  }
  
  .reel-video {
    width: 100%;
    border-radius: 8px;
  }
  
  .reel-overlay {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.3);
    opacity: 0;
    transition: opacity 0.2s ease;
  }
  
  .reel-card:hover .reel-overlay {
    opacity: 1;
  }
  
  .reel-metadata {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    color: gray;
    padding: 6px 8px;
  }
  
  .reel-popup {
    position: fixed;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.75);
    z-index: 50;
  }
  
  .reel-popup video {
    max-width: 90vw;
    max-height: 90vh;
    border-radius: 8px;
  }
  
  .reel-popup-close {
    position: absolute;
    top: 10px;
    right: 10px;
    background: #333;
    color: white;
    padding: 5px 10px;
    border-radius: 50%;
    cursor: pointer;
    border: none;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Pages/AccountPage/Components/Reels/Styles/ReelsgridBottomLayout.css"],"names":[],"mappings":"EAAE;IACE,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB;EACF;;EAEA;IACE,kBAAkB;IAClB,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,wCAAwC;IACxC,eAAe;IACf,qDAAqD;IACrD,cAAc,EAAE,sBAAsB;IACtC,kBAAkB,EAAE,+BAA+B;IACnD,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,YAAY;AAChB;;EAEE;IACE,sBAAsB;IACtB,0CAA0C;EAC5C;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,8BAA8B;IAC9B,UAAU;IACV,6BAA6B;EAC/B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,QAAQ;IACR,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,+BAA+B;IAC/B,WAAW;EACb;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,YAAY;EACd","sourcesContent":["  .reels-grid {\n    display: flex;\n    gap: 16px;\n    justify-content: center;\n    flex-wrap: wrap;\n  }\n  \n  .cmn-reels-container {\n    width: 1000px;\n    height: 800px;\n    border-radius: 20px;\n    margin-left: 0px;\n    margin-top: -100px;\n    display: flex;\n    flex-direction: row;\n    gap: 50px\n  }\n\n  .reel-card {\n    position: relative;\n    background-color: white;\n    width: 100%;\n    max-width: 250px;\n    border-radius: 12px;\n    border-color: black;\n    overflow: hidden;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    cursor: pointer;\n    transition: transform 0.2s ease, box-shadow 0.2s ease;\n    flex: 0 0 auto; /* Prevents resizing */\n    margin-right: 10px; /* Adds spacing between reels */ \n    display: flex;\n    flex-direction: row;\n    gap: 10px;\n    margin-top: 100px;\n    height: 40px;\n}\n  \n  .reel-card:hover {\n    transform: scale(1.02);\n    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\n  }\n  \n  .reel-video {\n    width: 100%;\n    border-radius: 8px;\n  }\n  \n  .reel-overlay {\n    position: absolute;\n    inset: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: rgba(0, 0, 0, 0.3);\n    opacity: 0;\n    transition: opacity 0.2s ease;\n  }\n  \n  .reel-card:hover .reel-overlay {\n    opacity: 1;\n  }\n  \n  .reel-metadata {\n    display: flex;\n    justify-content: space-between;\n    font-size: 12px;\n    color: gray;\n    padding: 6px 8px;\n  }\n  \n  .reel-popup {\n    position: fixed;\n    inset: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: rgba(0, 0, 0, 0.75);\n    z-index: 50;\n  }\n  \n  .reel-popup video {\n    max-width: 90vw;\n    max-height: 90vh;\n    border-radius: 8px;\n  }\n  \n  .reel-popup-close {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    background: #333;\n    color: white;\n    padding: 5px 10px;\n    border-radius: 50%;\n    cursor: pointer;\n    border: none;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
